// extracted by mini-css-extract-plugin
export default {"truncatedText":"truncateWithTooltip_truncatedText__+puXh"};